import { FilterInput, FilterOperator } from '@jusbrasil-web/shared-apollo-client/types'

export const getClusterQueryFilter = (clusterId: string): FilterInput[] => [
  {
    field: 'addons.legal_thesis_cluster_ids',
    operator: FilterOperator.Matchexact,
    value: clusterId,
  },
]
